let LOGGED_IN_AS_STUDENT = 0
let LOGGED_IN_AS_ADMIN = 1
let NOT_LOGGED_IN = -1

let PORT = '/'
export { LOGGED_IN_AS_STUDENT, LOGGED_IN_AS_ADMIN, NOT_LOGGED_IN, PORT }
